<div class="w-full flex flex-col">
    <div class="w-full flex justify-end">
        <button [matMenuTriggerFor]="menu"
            mat-raised-button 
            class="w-full md:w-auto rounded-sm m-0.5 md:mr-0.5">
            Emitir Nuevo Documento
        </button>
        
        <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item
                *hasPermissions="'generar_ficha_registro'; modulos ['DetalleBienCultural']" 
                (click)="agregarDocumento(true)">Generar Ficha de Registro</button>
            <button mat-menu-item 
                *hasPermissions="'emitir_documentos_oficiales'; modulos ['DetalleBienCultural']" 
                (click)="agregarDocumento(false)">Emitir Documento Oficial</button>
        </mat-menu>
    </div>
    <div class="w-full mt-4">
        <generated-documents 
            [documentos]="documentosEmitidos$ | async"
            [bienCulturalUuid]="this.uu_id"
            (abrirDrawer)="abrirDrawer.emit($event)"
            >
        </generated-documents>
    </div>

</div>